import { useRouteTransitionEffect } from './useRouteTransitionEffect';
import { routeResetRules } from '@config/route-store-reset';

export const useRouteStoreReset = (pathname: string): void => {
	useRouteTransitionEffect(pathname, (currentPath, previousPath) => {
		const context = { currentPath, previousPath };
		routeResetRules.forEach((rule) => {
			if (rule.shouldRun(context)) {
				rule.run(context);
			}
		});
	});
};
